export default __webpack_public_path__ + "static/media/RedMarkerNoText.131ca000.svg";